import {ValueRetrieverBase} from "./Core/ValueRetrieverBase";

import {ComparisonTypeEnum} from "../../Fields/Core/ConditionOptions";

export class MultipleValueRetriever extends ValueRetrieverBase{

    GetValue() {
        return this.Source.GetValue();
    }

    Compare(Comparison: ComparisonTypeEnum, Value: any) {
        if(Value==null)
            Value=[];

        if(!Array.isArray(Value))
            Value=[Value];


        let selectedValues=this.GetValue();
        if(!Array.isArray(selectedValues))
            selectedValues=[selectedValues];

        switch (Comparison) {
            case ComparisonTypeEnum.Contains:
                return selectedValues.some(x=>Value.some(y=>y.toString()==x.toString()));
            case ComparisonTypeEnum.NotContains:
                return !selectedValues.some(x=>Value.some(y=>y.toString()==x.toString()));
            case ComparisonTypeEnum.IsEmpty:
                return Value.length==0;
            case ComparisonTypeEnum.IsNotEmpty:
                return Value.length>0;

        }
    }

}